import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function Faq({ items }) {
  const [open, setOpen] = useState(null);

  return (
    <div className="mx-auto max-w-3xl" data-testid="faq-list">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div
            key={i}
            className="mb-3.5 overflow-hidden rounded-2xl border border-line bg-warm"
            data-testid={`faq-item-${i}`}
          >
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left md:px-7"
              data-testid={`faq-trigger-${i}`}
            >
              <span className="font-serif text-lg text-pine md:text-xl">{item.q}</span>
              <motion.span
                animate={{ rotate: isOpen ? 45 : 0 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                className="flex-none text-spring"
              >
                <Plus strokeWidth={1.8} />
              </motion.span>
            </button>
            <motion.div
              initial={false}
              animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="overflow-hidden"
            >
              <p className="px-6 pb-6 text-[1rem] text-soft md:px-7">{item.a}</p>
            </motion.div>
          </div>
        );
      })}
    </div>
  );
}
